export default {
  text: 'Hello World!'
}
